import { useRef } from 'react';

export const useStudioHeaderNavigation = () => {
  const shelvesRef = useRef<HTMLDivElement>(null);
  return { shelvesRef };
};
